import { ExchangeId } from "../types";

export interface ExchangeConfig {
  id: ExchangeId;
  label: string;
  wsUrl: string;
  logo: string;
  logoWebp?: string;
  referralUrl: string;
}

export const EXCHANGES: Record<ExchangeId, ExchangeConfig> = {
  nobitex: {
    id: "nobitex",
    label: "نوبیتکس",
    wsUrl: "wss://ws.nobitex.ir/connection",
    logo: "/exchanges/nobitex.png",
    logoWebp: "/exchanges/nobitex-80.webp",
    referralUrl: "https://nobitex.ir/signup/?refcode=8D67647",
  },
  wallex: {
    id: "wallex",
    label: "والکس",
    wsUrl: "wss://api.wallex.ir",
    logo: "/exchanges/wallex.png",
    logoWebp: "/exchanges/wallex-80.webp",
    referralUrl: "https://wallex.ir/signup?ref=77dz8xdq",
  },
  bitpin: {
    id: "bitpin",
    label: "بیت‌پین",
    wsUrl: "wss://ws.bitpin.ir",
    logo: "/exchanges/bitpin.png",
    logoWebp: "/exchanges/bitpin-80.webp",
    referralUrl: "https://bitpin.ir/signup/?refcode=fv2j04oqwy",
  },
};
